module.exports = "/static/img/Vector.1fc33316e3eb8b988962f86e0a834e8c.png";